import { baseApi } from './baseApi';

export const galleryApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getGallery: builder.query({
      query: (queryString = '') => ({
        url: queryString ? `gallery/list?${queryString}` : 'gallery/list',
        method: 'GET',
      }),
      providesTags: ['Gallery'],
    }),

    createGallery: builder.mutation({
      query: (body) => ({
        url: 'gallery/create',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Gallery'],
    }),

    deleteGallery: builder.mutation({
      query: ({ id, force = false }) => ({
        url: force ? `gallery/delete/${id}?force=true` : `gallery/delete/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Gallery'],
    }),
  }),
});

export const {
  useGetGalleryQuery,
  useCreateGalleryMutation,
  useDeleteGalleryMutation,
} = galleryApi;

